import React from "react";
import CustomDatePickerInput from "./CustomDatePickerInput";

interface ICustomEndDate {
  source: string;
  comparison?: string;
  label?: string;
  parentStartDate?: string;
  parentEndDate?: string;
  excludeDates?: IExcludeDates[];
  isWeekdays?: boolean;
}

const StudentScheduleStartDateInput = ({
  source,
  label,
  parentStartDate,
  parentEndDate,
  excludeDates,
  isWeekdays,
}: ICustomEndDate) => {
  return (
    <>
      <CustomDatePickerInput
        name={source}
        label={label}
        min={parentStartDate}
        max={parentEndDate}
        excludeDates={excludeDates}
        isWeekDays={isWeekdays}
      />
    </>
  );
};

export default StudentScheduleStartDateInput;
